<template>
  <div class="Mission justify-center" v-if="mission">
    <div v-if="selected === null">
    </div>
    <transition name=fade>
      <div class="wrapper" v-if="selected === 'list'">
        <mission
          v-for="(mission, i) in mission"
          :key=i
          :mission="mission"
          :order=i
          @select="select"
        ></mission>
      </div>
    </transition>
    <transition name=fade>
      <div class="detail d-flex" v-if="selected !== null && selected !== 'list'">
        <div class="map" :style="{backgroundImage: 'url(/static/img/map/' + selected.code + '.png'}">
        </div>
        <div class="info flex-1 relative text-left">
          <div class="close">
            <div class="absolute" @click="select('list')"></div>
          </div>
          <div class="cover justify-align-center flex-direction-column text-center" style="gap: .5em" :style="{backgroundImage: 'url(/static/img/mission/' + selected.code + '.jpg)'}">
            <div class="absolute-full" style="z-index: 1">
              <h1 class="m-0">{{ selected.name }}</h1>
              <h2 class="m-0">{{ selected.code.toUpperCase() }}</h2>
              <p>{{ selected.desc }}</p>
              <div class="score absolute" v-if="selected.scores">
                <small>획득 점수</small>
                <span class="relative" :class="['rank' + (i + 1)]" v-for="(score, i) in selected.scores" :key=i @click="showWinner = editable ? i : null">
                  {{ score }}
                  <span class="winner absolute">{{ getPlayerName(selected.winner[i]) }}</span>
                </span>
              </div>
              <div class="completed" :class="{on: selected.completed, editable}" @click="toggleCompleted"><img src="/static/img/completed.png"></div>
            </div>
          </div>
          <div class="wrapper">
            <ol v-if="selected.rules">
              <li class="rule" v-for="(rule, i) in selected.rules" :key=i>{{ rule }}</li>
            </ol>
            <div class="character d-flex mx-1" v-if="selected.character">
              <div class="label d-flex align-center">전용 캐릭터</div>
              <img :src="'/static/img/' + selected.character + '_Portrait.png'" style="width: 50px;">
            </div>
            <Beefalo v-if="selected.code === 'beefalo'" />
            <WX78 v-if="selected.code === 'wx-78'" />
            <Warly v-if="selected.code === 'warly'" />
            <Boat v-if="selected.code === 'boat'" />
            <Lucy v-if="selected.code === 'woodie'" />
            <Webber v-if="selected.code === 'webber'" />
            <PVP v-if="selected.code === 'pvp'" />
            <Woodie v-if="selected.code === 'special'" />
            <Willow v-if="selected.code === 'willow'" />
          </div>
        </div>
      </div>
    </transition>
    <Winner v-if="showWinner != null" :players=players :mission=selected :i=showWinner @close="showWinner = null" />
  </div>
</template>

<script>
import mission from './mission'
import Beefalo from './Beefalo'
import WX78 from './WX-78'
import Warly from './Warly'
import Boat from './Boat'
import Lucy from './Lucy'
import Webber from './Webber'
import PVP from './PVP'
import Woodie from './Woodie'
import Willow from './Willow'
import Winner from './Winner'

export default {
  name: 'Mission',
  components: { mission, Beefalo, WX78, Warly, Boat, Lucy, Webber, PVP, Woodie, Willow, Winner },
  props: ['mission', 'permission', 'players'],
  data: () => ({
    selected: 'list',
    showWinner: null
  }),
  computed: {
    editable () {
      return ['master', 'manager'].includes(this.permission)
    }
  },
  methods: {
    select (mission) {
      this.selected = null
      setTimeout(() => {
        this.selected = mission
        this.winner = mission.winner
      }, 500)
    },
    toggleCompleted () {
      if (!this.editable) return
      this.$socket.client.emit('updateCompleted', {
        code: this.selected.code,
        completed: !this.selected.completed
      })
    },
    getPlayerName (id) {
      try {
        return this.players.find(p => p.id === id).name
      } catch (err) {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  margin: 40px auto 0;
  padding: 0 1em;
  max-width: 1080px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease-in-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.detail {
  width: 100%;
  height: calc(100vh - 56px);
}
.detail>div {
  overflow-y: auto;
}
.map {
  width: 50%;
  background-position: center;
  background-size: cover;
}
.cover {
  position: relative;
  width: 100%;
  height: 100%;
  color: white;
  background-attachment: fixed;
  background-size: contain;
  background-position: calc((100vw - 100vh - 170px)/2);
  background-repeat: no-repeat;
}
.cover:before {
  display: block;
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url(https://static.dnf-universe.com/img/banner_cover2.png) repeat;
}
.cover .score {
  bottom: 1em;
  right: 1em;
  user-select: none;
}
.cover .score>span {
  display: inline-block;
  margin-left: .5em;
  padding: .5em;
  width: 25px;
  color: white;
  text-align: center;
  text-shadow: 0 0 2px black;
  border-radius: 10px;
  background-image: url(/static/img/prize/texture.jpg);
  background-size: 69px;
  background-position-x: -10px;
  background-repeat: no-repeat;
}
.score span.rank2 {
  background-position-y: -36px;
}
.score span.rank3 {
  background-position-y: -72px;
}
.score .winner {
  left: 0;
  top: -22px;
  width: 40px;
  font-size: 12px;
}
.cover .completed img {
  width: 200px;
}
.cover .completed:not(.on) {
  filter: grayscale(1);
}
.cover .completed:not(.on):not(.editable) {
  display: none;
}
.character {
  border: solid 1px #aaa;
  border-radius: 1em;
}
.character .label {
  padding: 0 .5em 0 1em;
  color: white;
  background: black;  
  border-radius: 1em 0 0 1em;
}
.close {
  position: sticky;
  top: 0;
  height: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
.close>div {
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: linear-gradient(180deg, black, transparent);
  transition: opacity .3s;
  opacity: 0;
}
.detail>div:hover .close>div {
  opacity: 1;
}
.close>div::after {
  content: '🠔';
  position: absolute;
  top: 5px;
  left: 13px;
  color: white;
  font-size: 30px;
  cursor: pointer;
}
@media screen and (max-width: 1080px) {
}
@media screen and (max-width: 860px) {
}
@media screen and (max-width: 640px) {
}
@media screen and (max-width: 540px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Mission/index.vue